import e from"./fails.js";var a=e,n=function(r){return a(function(){var t=""[r]('"');return t!==t.toLowerCase()||t.split('"').length>3})};export{n as default};
